"use client";

import { c as _c } from "react/compiler-runtime";
import { TrackEventContext } from "./context";
export const TrackEventProvider = t0 => {
  const $ = _c(5);
  const {
    trackEvent,
    children
  } = t0;
  if (!trackEvent) {
    return children;
  }
  let t1;
  if ($[0] !== trackEvent) {
    t1 = {
      trackEvent
    };
    $[0] = trackEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <TrackEventContext.Provider value={t1}>{children}</TrackEventContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};